// import components
import { styled, Box, FormControlLabel } from '@mui/material';
import { ControlledTextField } from 'components/shared/ControlledFields';

export const StyledFilterComponentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: theme.spacing(2),
  gap: theme.spacing(4)
}));

export const StyledSearchFieldBox = styled(Box)(() => ({
  width: '300px'
}));

export const StyledControlledTextField = styled(ControlledTextField, {
  shouldForwardProp: (prop) => prop !== 'timeHighlight' // don't forward this prop to the DOM
})<{ timeHighlight?: boolean }>(({ theme, timeHighlight }) => ({
  ...(timeHighlight && {
    '& .MuiInputBase-input': {
      color: theme.palette.primary.main
    }
  })
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  gap: theme.spacing(2)
}));
